<div class="modal-header d-flex justify-content-between align-items-center">
    <h5 class="modal-title">Evaluation Details</h5>
    <div class="d-flex align-items-center">
        <button class="btn btn-secondary me-3" (click)="downloadImage()">
            <i class="bx bx-download me-1 font-20 text-white"></i> Download
        </button>
        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"
            (click)="activeModal.close('Close')" tabindex="-1"></button>
    </div>
</div>
<div id="evaluation-content">
    <div class="modal-body">
        <div class="payslip-container">
            <div class="company-header d-flex align-items-center">
                <img src="assets/images/firecodex-logo.png" alt="Firecodex Logo" class="company-logo me-3">
                <div class="company-info">
                    <h2 class="mb-0">Firecodex, PieTechies Pvt. Ltd.</h2>
                    <p class="mb-0">#198, 2nd Floor, CMH Road, Indiranagar, Bangalore - 5600</p>
                </div>
            </div>
            <h3 class="payslip-title">
                Evaluation Report
            </h3>
            <div class="employee-bank-details">
                <table class="details-table">
                    <tr>
                        <td><strong>Employee Code:</strong> {{ assessmentData?.assessmentDto?.empCode || 'Nill' }}</td>
                        <td><strong>Employee Name:</strong> {{ assessmentData.assessmentDto?.appraiseeName || 'Nill' }}
                        </td>
                    </tr>
                    <tr>
                        <td><strong>Self Rating:</strong> {{ assessmentData?.assessmentDto?.selfRating || 'Nill'
                            }}</td>
                        <td><strong>Lone Rating:</strong> {{ assessmentData?.assessmentDto?.loneRating || 'Nill' }}
                        </td>
                    </tr>
                    <tr>
                        <td><strong>Appraisal Name:</strong> {{ assessmentData?.assessmentDto?.appraisalName || 'Nill'
                            }}
                        </td>
                        <td><strong>Email:</strong> {{ assessmentData.assessmentDto?.email || 'Nill' }}
                        </td>
                    </tr>
                    <tr>
                        <td><strong>Appraisal Status:</strong> {{ assessmentData?.assessmentDto?.status|| 'Nill' }}
                        </td>
                        <td><strong>Evaluation Comment:</strong> {{ assessmentData.evaluationDto?.comments || 'Nill' }}
                        </td>
                    </tr>
                    <tr>
                        <td><strong>Performance:</strong> {{ assessmentData?.assessmentDto?.performanceLabel|| 'Nill' }}
                        </td>
                        <td><strong>Metric:</strong> {{ assessmentData.assessmentDto?.metricName || 'Nill' }}
                        </td>
                    </tr>
                    <tr>
                        <td><strong>Hike:</strong> {{ hikeValue || 'Nill' }}
                        </td>
                        <td>
                            <strong>Promoted Role:</strong>
                            {{ assessmentData.assessmentDto?.promotable === true ? 'Yes' : 'No' }}
                        </td>

                    </tr>
                </table>
            </div>
        </div>
    </div>
</div>